import React, { useState } from 'react';
import PassengerModal from '../components/PassengerModal';

const Passenger = ({ tripType = 'Round trip', passengerNumber = 2 }) => {
  const [email, setEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [phoneType, setPhoneType] = useState('CEL');
  const [countryCode, setCountryCode] = useState('+1');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [tripPurpose, setTripPurpose] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPassenger, setSelectedPassenger] = useState(null);

  const handleOpenModal = (passengerIndex) => {
    setSelectedPassenger(passengerIndex);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedPassenger(null);
    setIsModalOpen(false);
  };

  const renderPassengerCards = () => {
    const cards = [];
    for (let i = 1; i <= passengerNumber; i++) {
      cards.push(
        <fieldset key={i} className="mb-8 w-1/3 max-w-md">
          <div className="border-2 border-gray-400 shadow-lg rounded-lg p-6">
            <div className="text-center">
              <div className="mb-4">
                <div className="flex items-center justify-center mb-2">
                  <svg version="1.1" className="w-8 h-8 text-gray-900 mr-2" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24" height="24" viewBox="0 0 32 32" style={{enableBackground:"new 0 0 32 32"}} xmlSpace="preserve" fill="currentColor" aria-hidden="true">
                    <g>
                      <path d="M16,14c3.3,0,6-2.7,6-6s-2.7-6-6-6s-6,2.7-6,6S12.7,14,16,14z M16,4c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S13.8,4,16,4z M30,22v2h-4v4h-2v-4h-4v-2h4v-4h2v4H30z M16,28c2.1,0,4.2-0.6,6-1.6V28v0.6c-1.9,0.9-3.9,1.4-6,1.4c-4,0-7.8-1.7-10.5-4.7 C5.2,24.9,5,24.4,5,23.9V22c0-3.3,2.7-6,6-6h11v2H11c-2.2,0-4,1.8-4,4v1.9C9.3,26.5,12.6,28,16,28z"/>
                      <rect y="0" fill="none" width="32" height="32"/>
                    </g>
                  </svg>
                  <span className="text-lg font-medium text-gray-900">Passenger {i}</span>
                </div>
                <div>&nbsp;</div>
                <button 
                  onClick={() => handleOpenModal(i)}
                  className="w-full bg-white border-2 border-aa-blue text-aa-blue px-4 py-3 rounded-lg font-medium hover:bg-blue-50 transition-colors"
                >
                  Enter passenger details
                </button>
              </div>
            </div>
          </div>
        </fieldset>
      );
    }
    return cards;
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-6xl mx-auto  py-6">
        {/* Page Header */}
        <div className="mb-6">
          <h1 className="text-[42px] font-bold text-gray-900 mb-4">Passengers</h1>
          <div className="pt-12 ">
            <a href="/search" className="text-aa-blue hover:underline">
              « <span className="sr-only">start a </span>New search
            </a>
          </div>
        </div>

        {/* Know Before You Go Section */}
        <div id="knowBeforeYouGo" className="mt-8 mb-6">
          <div className="bg-blue-50 border-l-4 border-aa-dark-blue border-t border-r border-b p-6 rounded-lg" role="alert">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <svg width="32" height="32" className="text-blue-600" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <g clipPath="url(#clip0_7669_34263_know)">
                    <path d="M8 1C4.15 1 1 4.15 1 8C1 11.85 4.15 15 8 15C11.85 15 15 11.85 15 8C15 4.15 11.85 1 8 1ZM8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14ZM8.5 6.5V12H7.5V6.5H8.5ZM8.75 4.75C8.75 5.15 8.4 5.5 8 5.5C7.6 5.5 7.25 5.15 7.25 4.75C7.25 4.35 7.6 4 8 4C8.4 4 8.75 4.35 8.75 4.75Z" fill="currentColor"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_7669_34263_know">
                      <rect width="16" height="16" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="flex-1">
                <div className="text-xl font-bold text-gray-900 mb-4">
                  Know before you go
                </div>
                <div className="knowBeforeYouGoTitle font-semibold text-gray-900 mb-3">
                  International travel requires a valid passport
                </div>
                <div className="text-gray-700 mb-4">
                  If you have a U.S. passport, check the expiration date; many countries require that your passport be valid for at least six months after you arrive. For more information on destinations and passports, visit{' '}
                  <a 
                    href="https://travel.state.gov/content/travel.html" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-aa-blue hover:underline inline-flex items-center"
                  >
                    travel.state.gov
                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                </div>
                <div className="knowBeforeYouGoTitle font-semibold text-gray-900 mb-3">
                  Visas and travel document requirements
                </div>
                <div className="text-gray-700 mb-4">
                  Your trip may require a visa and additional travel documents. These requirements can vary depending on your nationality, destination, and purpose of visit. Make sure you have the necessary documents by checking the latest visa and travel requirements for your destination.
                </div>
                <div className="knowBeforeYouGoLink">
                  <a 
                    href="https://apply.joinsherpa.com/map?affiliateId=americanairlines&from=bannerContainerB2&language=en-US" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-aa-blue hover:underline inline-flex items-center font-medium"
                  >
                    Find what documents you need for your trip
                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Trip Header */}
        <div className="bg-white  p-6 mb-6">
          <div className="text-lg font-semibold text-aa-blue mb-2">{tripType}</div>
          <h2 className="text-[32px] font-semibold text-gray-900 mb-2">Newark to Los Angeles</h2>
          <div className="text-gray-600 text-[18px]">Saturday, August 30, 2025 to Wednesday, September 10, 2025</div>
        </div>

        {/* Trip Total Section */}
        <section className="mb-6">
          <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
            <div className="flex flex-col lg:flex-row">
              {/* Trip Total - Left Side */}
              <div className="flex-1 lg:flex-[1.5] p-6 bg-white lg:rounded-l-lg">
                <h3 className="text-[28px] font-normal text-gray-600">Your trip total</h3>
                <div className="text-3xl font-normal text-aa-blue mb-4">$543.18</div>
                <div className="mt-8">
                  <p className="text-[12px] text-gray-600 mb-1">Price for all passengers</p>
                  <a href="#" className="text-aa-blue hover:underline text-[12px] inline-flex items-center mb-4">
                    Price and tax information 
                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                  <p className="text-[12px] text-gray-600 mt-1 mb-1">Includes taxes and carrier imposed fees</p>
                  <a href="#" className="text-aa-blue hover:underline text-[12px] inline-flex items-center">
                    Bag and options fees
                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                </div>
              </div>
              
              {/* Card Offer - Right Side */}
              <div className="flex-1 lg:flex-[3.5] bg-gray-100 lg:rounded-r-lg p-4 min-h-[300px]">
                <div className="citi-acq-calc-container h-full">
                  <div className="main-offer-sec flex">
                    {/* Left Side - Offer Details */}
                    <div className="offer-section red flex-[3]">
                      <div className="offer-details-container">
                        {/* NEW CARDMEMBER OFFER Banner */}
                        <div className="mb-3">
                          <div className="citi-ad-banner bg-red-600 text-white text-xs font-bold px-3 py-1 rounded inline-block">
                            NEW CARDMEMBER OFFER
                          </div>
                        </div>

                        {/* Credit Offer Box */}
                        <div className="credit-offer-box">
                          <div className="credit-miles mb-4">
                            {/* Offer Statement Box */}
                            <div className="offer-stmt-box bg-white rounded-lg p-4 border border-gray-200 mb-4">
                              <div className="small-text text-sm text-gray-700 mb-3">Earn up to a</div>
                              <div className="flex items-center justify-center space-x-4 mb-4">
                                <div className="offer-stmt text-center">
                                  <span className="ecm-text block text-2xl font-bold text-gray-900">$200</span>
                                  <span className="small-text-ecm text-[14px] font-semibold text-gray-900">statement credit</span>
                                </div>
                                <div className="plus-icon">
                                  <svg className="adc-icon w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                                  </svg>
                                </div>
                                <div className="offer-stmt text-center">
                                  <span className="ecm-text block text-2xl font-bold text-gray-900">40,000</span>
                                  <span className="small-text-ecm font-semibold text-[14px] text-gray-900">bonus miles</span>
                                </div>
                              </div>

                              {/* Cost Breakdown - Integrated */}
                              <div className="space-y-2">
                                <div className="flex justify-between">
                                  <span className="text-sm text-gray-700">Pay today:</span>
                                  <span className="text-sm font-medium text-gray-900">$543.18</span>
                                </div>
                                <div className="flex justify-between">
                                  <span className="text-sm text-gray-700">Card statement credit:</span>
                                  <span className="text-sm font-medium text-gray-700">-$200.00</span>
                                </div>
                                <div className="flex justify-between pt-2 border-t border-gray-200">
                                  <span className="text-sm font-semibold text-gray-900">Total after statement credit:</span>
                                  <span className="text-sm font-bold text-gray-900">$343.18</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Terms Section */}
                      <div className="terms-section mt-4">
                        <div className="desc-img-terms flex items-start space-x-2 mb-3">
                          <div className="citi-terms flex-1">
                            <span className="text-lg flex text-gray-600 leading-relaxed">
                              Plus, get your first checked bag free on domestic American Airlines itineraries Terms apply. 
                            </span>
      
                          </div>
                        </div>

                        {/* Learn More Button */}
                        <div className="citi-link-container">
                          <a 
                            href="https://creditcards.aa.com/credit-cards/citi-platinum-card-american-airlines-bp/?utm_medium=referral&utm_source=aa&utm_campaign=bppax" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="adc-button learn-link inline-flex items-center px-3 py-3 border border-aa-dark-blue text-aa-dark-blue font-semibold rounded hover:bg-blue-50 transition-colors  text-[16px]"
                            aria-label="Opens in a new window"
                          >
                            Learn more
                          <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                         </svg>
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Right Side - Card Image */}
                    <div className="citi-image-terms-container flex-[2] ml-4 flex items-center justify-center pb-10">
                      <img 
                        id="citiCardImage" 
                        className="citi-card-image w-48 h-auto max-w-full" 
                        src="https://www.aa.com/content/images/aadvantage-program/credit-card/desktop/hero-card-platinum.png" 
                        alt="Citi / AAdvantage Platinum Select World Elite Mastercard"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Login Notification */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <div className="flex items-center">
            <div className="flex-1">
              <span className="text-gray-900 font-semibold flex items-center">
                <svg className="w-6 h-6 mr-2 text-aa-blue" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_7669_34263)">
                    <path d="M8 1C4.15 1 1 4.15 1 8C1 11.85 4.15 15 8 15C11.85 15 15 11.85 15 8C15 4.15 11.85 1 8 1ZM8 14C4.7 14 2 11.3 2 8C2 4.7 4.7 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14ZM8.5 6.5V12H7.5V6.5H8.5ZM8.75 4.75C8.75 5.15 8.4 5.5 8 5.5C7.6 5.5 7.25 5.15 7.25 4.75C7.25 4.35 7.6 4 8 4C8.4 4 8.75 4.35 8.75 4.75Z" fill="currentColor"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_7669_34263">
                      <rect width="16" height="16" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                Log in to retrieve your saved companion information.
                <a href="#" className="ml-2 text-aa-blue hover:underline font-medium">
                  Log in →
                </a>
              </span>
            </div>
          </div>
        </div>

        {/* Passenger Information */}
        <h2 className="text-2xl font-semibold text-gray-900 mb-6">Passenger information</h2>

        <div className="flex flex-wrap gap-4">
          {renderPassengerCards()}
        </div>

        {/* Trip Contact Information */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Trip contact information</h2>
          <div className="text-gray-600 mb-4">
            Enter contact information to get important trip updates, including flight status changes or delays.
          </div>
          <div className="text-sm text-gray-600 mb-6">
            <span>( <span className="text-red-500">•</span> Required)</span>
          </div>

          <div className="bg-white  p-4">
            {/* All Contact Fields Inline */}
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
              <div className="md:col-span-3">
                <label htmlFor="email" className="block text-sm font-semibold text-gray-500 mb-2">
                  Primary email <span className="text-red-500">•</span>
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-md focus:ring-2 focus:ring-aa-blue focus:border-aa-blue transition-colors text-gray-900 placeholder-gray-500"
                  required
                />
              </div>
              <div className="md:col-span-3">
                <label htmlFor="confirmEmail" className="block text-sm font-semibold text-gray-500 mb-2">
                  Confirm primary email <span className="text-red-500">•</span>
                </label>
                <input
                  type="email"
                  id="confirmEmail"
                  value={confirmEmail}
                  onChange={(e) => setConfirmEmail(e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-md focus:ring-2 focus:ring-aa-blue focus:border-aa-blue transition-colors text-gray-900 placeholder-gray-500"

                  required
                />
              </div>
              <div className="md:col-span-2">
                <label htmlFor="phoneType" className="block text-sm font-semibold text-gray-500 mb-2">
                  Primary phone type <span className="text-red-500">•</span>
                </label>
                <div className="relative">
                  <select
                    id="phoneType"
                    value={phoneType}
                    onChange={(e) => setPhoneType(e.target.value)}
                    className="w-full px-2 py-3 pr-6 border-2 border-gray-300 rounded-md focus:ring-2 focus:ring-aa-blue focus:border-aa-blue transition-colors text-aa-blue bg-white appearance-none text-sm"
                    required
                  >
                    <option value="CEL">Mobile</option>
                    <option value="HOME">Home</option>
                    <option value="BUSINESS">Business</option>
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-1 pointer-events-none text-aa-dark-blue">
                    <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <g clipPath="url(#clip0_6925_33198)">
                        <path d="M8 11.5L3.5 6H12.5L8 11.5Z" fill="currentColor"></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_6925_33198">
                          <rect width="16" height="16" fill="white" transform="translate(16) rotate(90)"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="md:col-span-4">
                <label htmlFor="phoneNumber" className="block text-sm font-semibold text-gray-500 mb-2">
                  Primary phone number <span className="text-red-500">•</span>
                </label>
                <div className="flex gap-2">
                  <div className="relative" style={{width: '90px'}}>
                    <input
                      type="text"
                      value={countryCode}
                      readOnly
                      className="w-full px-2 py-3 pr-5 border-2 border-gray-300 rounded-md focus:ring-2 focus:ring-aa-blue focus:border-aa-blue transition-colors text-aa-blue bg-white text-sm cursor-pointer"
                    />
                    <select
                      id="countryCode"
                      value={countryCode}
                      onChange={(e) => setCountryCode(e.target.value)}
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                      required
                    >
                      <option value="+1">UNITED STATES +1</option>
                      <option value="+93">AFGHANISTAN +93</option>
                      <option value="+355">ALBANIA +355</option>
                      <option value="+213">ALGERIA +213</option>
                      <option value="+1">AMERICAN SAMOA +1</option>
                      <option value="+376">ANDORRA +376</option>
                      <option value="+244">ANGOLA +244</option>
                      <option value="+1">ANGUILLA +1</option>
                      <option value="+672">ANTARCTICA +672</option>
                      <option value="+1">ANTIGUA AND BARBUDA +1</option>
                      <option value="+54">ARGENTINA +54</option>
                      <option value="+374">ARMENIA +374</option>
                      <option value="+297">ARUBA +297</option>
                      <option value="+61">AUSTRALIA +61</option>
                      <option value="+43">AUSTRIA +43</option>
                      <option value="+994">AZERBAIJAN +994</option>
                      <option value="+1">BAHAMAS +1</option>
                      <option value="+973">BAHRAIN +973</option>
                      <option value="+880">BANGLADESH +880</option>
                      <option value="+1">BARBADOS +1</option>
                      <option value="+375">BELARUS +375</option>
                      <option value="+32">BELGIUM +32</option>
                      <option value="+501">BELIZE +501</option>
                      <option value="+229">BENIN +229</option>
                      <option value="+1">BERMUDA +1</option>
                      <option value="+975">BHUTAN +975</option>
                      <option value="+591">BOLIVIA +591</option>
                      <option value="+599">BONAIRE +599</option>
                      <option value="+387">BOSNIA AND HERZEGOVINA +387</option>
                      <option value="+267">BOTSWANA +267</option>
                      <option value="+55">BRAZIL +55</option>
                      <option value="+673">BRUNEI DARUSSALAM +673</option>
                      <option value="+359">BULGARIA +359</option>
                      <option value="+226">BURKINA FASO +226</option>
                      <option value="+257">BURUNDI +257</option>
                      <option value="+855">CAMBODIA +855</option>
                      <option value="+237">CAMEROON +237</option>
                      <option value="+1">CANADA +1</option>
                      <option value="+238">CAPE VERDE +238</option>
                      <option value="+1">CAYMAN ISLANDS +1</option>
                      <option value="+236">CENTRAL AFRICAN REPUBLIC +236</option>
                      <option value="+235">CHAD +235</option>
                      <option value="+56">CHILE +56</option>
                      <option value="+86">CHINA +86</option>
                      <option value="+61">CHRISTMAS ISLAND +61</option>
                      <option value="+61">COCOS (KEELING) ISLANDS +61</option>
                      <option value="+57">COLOMBIA +57</option>
                      <option value="+269">COMOROS +269</option>
                      <option value="+242">CONGO (BRAZZAVILLE) +242</option>
                      <option value="+243">CONGO (KINSHASA) +243</option>
                      <option value="+682">COOK ISLANDS +682</option>
                      <option value="+506">COSTA RICA +506</option>
                      <option value="+385">CROATIA +385</option>
                      <option value="+53">CUBA +53</option>
                      <option value="+599">CURACAO +599</option>
                      <option value="+357">CYPRUS +357</option>
                      <option value="+420">CZECH REPUBLIC +420</option>
                      <option value="+45">DENMARK +45</option>
                      <option value="+253">DJIBOUTI +253</option>
                      <option value="+1">DOMINICA +1</option>
                      <option value="+1">DOMINICAN REPUBLIC +1</option>
                      <option value="+593">ECUADOR +593</option>
                      <option value="+20">EGYPT +20</option>
                      <option value="+503">EL SALVADOR +503</option>
                      <option value="+240">EQUATORIAL GUINEA +240</option>
                      <option value="+291">ERITREA +291</option>
                      <option value="+372">ESTONIA +372</option>
                      <option value="+268">ESWATINI +268</option>
                      <option value="+251">ETHIOPIA +251</option>
                      <option value="+500">FALKLAND ISLANDS +500</option>
                      <option value="+298">FAROE ISLANDS +298</option>
                      <option value="+679">FIJI +679</option>
                      <option value="+358">FINLAND +358</option>
                      <option value="+33">FRANCE +33</option>
                      <option value="+594">FRENCH GUIANA +594</option>
                      <option value="+689">FRENCH POLYNESIA +689</option>
                      <option value="+241">GABON +241</option>
                      <option value="+220">GAMBIA +220</option>
                      <option value="+995">GEORGIA +995</option>
                      <option value="+49">GERMANY +49</option>
                      <option value="+233">GHANA +233</option>
                      <option value="+350">GIBRALTAR +350</option>
                      <option value="+30">GREECE +30</option>
                      <option value="+299">GREENLAND +299</option>
                      <option value="+1">GRENADA +1</option>
                      <option value="+590">GUADELOUPE +590</option>
                      <option value="+1">GUAM +1</option>
                      <option value="+502">GUATEMALA +502</option>
                      <option value="+44">GUERNSEY +44</option>
                      <option value="+224">GUINEA +224</option>
                      <option value="+245">GUINEA-BISSAU +245</option>
                      <option value="+592">GUYANA +592</option>
                      <option value="+509">HAITI +509</option>
                      <option value="+39">HOLY SEE +39</option>
                      <option value="+504">HONDURAS +504</option>
                      <option value="+852">HONG KONG +852</option>
                      <option value="+36">HUNGARY +36</option>
                      <option value="+354">ICELAND +354</option>
                      <option value="+91">INDIA +91</option>
                      <option value="+62">INDONESIA +62</option>
                      <option value="+98">IRAN +98</option>
                      <option value="+964">IRAQ +964</option>
                      <option value="+353">IRELAND +353</option>
                      <option value="+972">ISRAEL +972</option>
                      <option value="+39">ITALY +39</option>
                      <option value="+225">IVORY COAST +225</option>
                      <option value="+1">JAMAICA +1</option>
                      <option value="+81">JAPAN +81</option>
                      <option value="+44">JERSEY +44</option>
                      <option value="+962">JORDAN +962</option>
                      <option value="+7">KAZAKHSTAN +7</option>
                      <option value="+254">KENYA +254</option>
                      <option value="+686">KIRIBATI +686</option>
                      <option value="+965">KUWAIT +965</option>
                      <option value="+996">KYRGYZSTAN +996</option>
                      <option value="+856">LAOS +856</option>
                      <option value="+371">LATVIA +371</option>
                      <option value="+961">LEBANON +961</option>
                      <option value="+266">LESOTHO +266</option>
                      <option value="+231">LIBERIA +231</option>
                      <option value="+218">LIBYA +218</option>
                      <option value="+423">LIECHTENSTEIN +423</option>
                      <option value="+370">LITHUANIA +370</option>
                      <option value="+352">LUXEMBOURG +352</option>
                      <option value="+853">MACAU +853</option>
                      <option value="+389">MACEDONIA +389</option>
                      <option value="+261">MADAGASCAR +261</option>
                      <option value="+265">MALAWI +265</option>
                      <option value="+60">MALAYSIA +60</option>
                      <option value="+960">MALDIVES +960</option>
                      <option value="+223">MALI +223</option>
                      <option value="+356">MALTA +356</option>
                      <option value="+692">MARSHALL ISLANDS +692</option>
                      <option value="+596">MARTINIQUE +596</option>
                      <option value="+222">MAURITANIA +222</option>
                      <option value="+230">MAURITIUS +230</option>
                      <option value="+269">MAYOTTE +269</option>
                      <option value="+52">MEXICO +52</option>
                      <option value="+691">MICRONESIA +691</option>
                      <option value="+373">MOLDOVA, REPUBLIC OF +373</option>
                      <option value="+377">MONACO +377</option>
                      <option value="+976">MONGOLIA +976</option>
                      <option value="+382">MONTENEGRO +382</option>
                      <option value="+1">MONTSERRAT +1</option>
                      <option value="+212">MOROCCO +212</option>
                      <option value="+258">MOZAMBIQUE +258</option>
                      <option value="+264">NAMIBIA +264</option>
                      <option value="+674">NAURU +674</option>
                      <option value="+977">NEPAL +977</option>
                      <option value="+31">NETHERLANDS +31</option>
                      <option value="+687">NEW CALEDONIA +687</option>
                      <option value="+64">NEW ZEALAND +64</option>
                      <option value="+505">NICARAGUA +505</option>
                      <option value="+227">NIGER +227</option>
                      <option value="+234">NIGERIA +234</option>
                      <option value="+683">NIUE +683</option>
                      <option value="+672">NORFOLK ISLAND +672</option>
                      <option value="+850">NORTH KOREA +850</option>
                      <option value="+1">NORTHERN MARIANA ISLANDS +1</option>
                      <option value="+47">NORWAY +47</option>
                      <option value="+968">OMAN +968</option>
                      <option value="+92">PAKISTAN +92</option>
                      <option value="+680">PALAU +680</option>
                      <option value="+507">PANAMA +507</option>
                      <option value="+675">PAPUA NEW GUINEA +675</option>
                      <option value="+595">PARAGUAY +595</option>
                      <option value="+51">PERU +51</option>
                      <option value="+63">PHILIPPINES +63</option>
                      <option value="+48">POLAND +48</option>
                      <option value="+351">PORTUGAL +351</option>
                      <option value="+1">PUERTO RICO +1</option>
                      <option value="+974">QATAR +974</option>
                      <option value="+262">REUNION +262</option>
                      <option value="+40">ROMANIA +40</option>
                      <option value="+7">RUSSIA +7</option>
                      <option value="+250">RWANDA +250</option>
                      <option value="+1">SAINT KITTS AND NEVIS +1</option>
                      <option value="+1">SAINT LUCIA +1</option>
                      <option value="+590">SAINT MARTIN +590</option>
                      <option value="+508">SAINT PIERRE AND MIQUELON +508</option>
                      <option value="+685">SAMOA +685</option>
                      <option value="+378">SAN MARINO +378</option>
                      <option value="+239">SAO TOME AND PRINCIPE +239</option>
                      <option value="+966">SAUDI ARABIA +966</option>
                      <option value="+221">SENEGAL +221</option>
                      <option value="+381">SERBIA +381</option>
                      <option value="+248">SEYCHELLES +248</option>
                      <option value="+232">SIERRA LEONE +232</option>
                      <option value="+65">SINGAPORE +65</option>
                      <option value="+1">SINT MAARTEN +1</option>
                      <option value="+421">SLOVAKIA +421</option>
                      <option value="+386">SLOVENIA +386</option>
                      <option value="+677">SOLOMON ISLANDS +677</option>
                      <option value="+252">SOMALIA +252</option>
                      <option value="+27">SOUTH AFRICA +27</option>
                      <option value="+82">SOUTH KOREA +82</option>
                      <option value="+34">SPAIN +34</option>
                      <option value="+94">SRI LANKA +94</option>
                      <option value="+290">ST HELENA +290</option>
                      <option value="+1">ST VINCENT AND THE GRENADINES +1</option>
                      <option value="+249">SUDAN +249</option>
                      <option value="+597">SURINAME +597</option>
                      <option value="+46">SWEDEN +46</option>
                      <option value="+41">SWITZERLAND +41</option>
                      <option value="+963">SYRIAN ARAB REPUBLIC +963</option>
                      <option value="+886">TAIWAN +886</option>
                      <option value="+992">TAJIKISTAN +992</option>
                      <option value="+255">TANZANIA +255</option>
                      <option value="+66">THAILAND +66</option>
                      <option value="+670">TIMOR LESTE +670</option>
                      <option value="+228">TOGO +228</option>
                      <option value="+690">TOKELAU +690</option>
                      <option value="+676">TONGA +676</option>
                      <option value="+1">TRINIDAD AND TOBAGO +1</option>
                      <option value="+216">TUNISIA +216</option>
                      <option value="+90">TURKEY +90</option>
                      <option value="+993">TURKMENISTAN +993</option>
                      <option value="+1">TURKS AND CAICOS ISLANDS +1</option>
                      <option value="+688">TUVALU +688</option>
                      <option value="+256">UGANDA +256</option>
                      <option value="+380">UKRAINE +380</option>
                      <option value="+971">UNITED ARAB EMIRATES +971</option>
                      <option value="+44">UNITED KINGDOM +44</option>
                      <option value="+598">URUGUAY +598</option>
                      <option value="+998">UZBEKISTAN +998</option>
                      <option value="+678">VANUATU +678</option>
                      <option value="+58">VENEZUELA +58</option>
                      <option value="+84">VIETNAM +84</option>
                      <option value="+1">VIRGIN ISLANDS, BRITISH +1</option>
                      <option value="+1">VIRGIN ISLANDS, U.S. +1</option>
                      <option value="+681">WALLIS AND FUTUNA ISLANDS +681</option>
                      <option value="+967">YEMEN +967</option>
                      <option value="+260">ZAMBIA +260</option>
                      <option value="+263">ZIMBABWE +263</option>
                    </select>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-1 pointer-events-none text-aa-dark-blue">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <g clipPath="url(#clip0_6925_33198_country)">
                          <path d="M8 11.5L3.5 6H12.5L8 11.5Z" fill="currentColor"></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_6925_33198_country">
                            <rect width="16" height="16" fill="white" transform="translate(16) rotate(90)"></rect>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <input
                    type="tel"
                    id="phoneNumber"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    maxLength="15"
                    className="flex-1 px-4 py-3 border-2 border-gray-300 rounded-md focus:ring-2 focus:ring-aa-blue focus:border-aa-blue transition-colors text-gray-900 placeholder-gray-500"
                    required
                  />
                </div>
              </div>
            </div>

            {/* Trip Purpose */}
            <div className='mt-8'>
              <label htmlFor="tripPurpose" className="block text-sm font-semibold text-gray-500 mb-2">
                Purpose of trip
              </label>
              <div className="grid grid-cols-1 md:grid-cols-12">
                <div className="md:col-span-3">
                  <div className="relative">
                <select
                  id="tripPurpose"
                  value={tripPurpose}
                  onChange={(e) => setTripPurpose(e.target.value)}
                  className="w-full px-4 py-3 pr-12 border-2 border-gray-300 rounded-md focus:ring-2 focus:ring-aa-blue focus:border-aa-blue transition-colors text-gray-900 bg-white appearance-none"
                >
                  <option value="">Choose an option</option>
                  <option value="BUSINESS">Business</option>
                  <option value="LEISURE">Leisure</option>
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-aa-dark-blue">
                  <svg width="24" height="24" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <g clipPath="url(#clip0_6925_33198_trip)">
                      <path d="M8 11.5L3.5 6H12.5L8 11.5Z" fill="currentColor"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_6925_33198_trip">
                        <rect width="16" height="16" fill="white" transform="translate(16) rotate(90)"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hazmat Section */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Use caution when packing</h2>
          <div className="text-gray-700 mb-6">
            Some everyday products, like electronic cigarettes and aerosol spray starch, can be dangerous when transported on the aircraft in carry-on and/or checked baggage. Changes in temperature or pressure can cause some items to leak, generate toxic fumes or start a fire. Carriage of prohibited items may result in fines or in certain cases imprisonment. Please ensure there are no forbidden hazardous materials in your baggage like:
          </div>

          {/* Hazmat Icons */}
          <div className="flex flex-wrap justify-center gap-6 mb-6">
            {[
              { 
                icon: <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32" height="32" viewBox="0 0 32 32" style={{enableBackground:"new 0 0 32 32"}} xmlSpace="preserve" fill="currentColor" aria-hidden="true">
                  <g>
                    <path d="M19,4h-6V2h6V4z M24,7v11v10c0,1.1-0.9,2-2,2H10c-1.1,0-2-0.9-2-2V18V7c0-1.1,0.9-2,2-2h12C23.1,5,24,5.9,24,7z M22,18V7H10v11v10h12V18z M19.8,17.6h-2.5l0.5-6.3c0-0.2-0.2-0.3-0.4-0.2l-5.3,6.1c-0.1,0.1,0,0.4,0.2,0.4h2.5l-0.5,6.3c0,0.2,0.2,0.3,0.4,0.2l5.3-6.1C20.1,17.8,20,17.6,19.8,17.6z"/>
                    <rect y="0" fill="none" width="32" height="32"/>
                  </g>
                </svg>, 
                text: 'Lithium batteries' 
              },
              { 
                icon: <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32" height="32" viewBox="0 0 32 32" style={{enableBackground:"new 0 0 32 32"}} xmlSpace="preserve" fill="currentColor" aria-hidden="true">
                  <g id="Layer_2">
                    <g>
                      <path d="M21,9h-0.2l-0.6-2.5c-0.2-0.9-1-1.5-1.9-1.5h-4.4c-0.9,0-1.7,0.6-1.9,1.5L11.2,9H11c-1.1,0-2,0.9-2,2v17c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V11C23,9.9,22.1,9,21,9z M13.8,7h4.4l0.5,2h-5.4L13.8,7z M21,11v12H11V11H21z M11,28v-3h10v3H11z M17,4h-2V2h2V4z"/>
                      <rect fill="none" width="32" height="32"/>
                    </g>
                  </g>
                </svg>, 
                text: 'Aerosol' 
              },
              { 
                icon: <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32" height="32" viewBox="0 0 32 32" style={{enableBackground:"new 0 0 32 32"}} xmlSpace="preserve" fill="currentColor" aria-hidden="true">
                  <g id="Layer_2">
                    <g>
                      <path d="M12.4,13.2c0.1,0.1,0.1,0.3,0.1,0.5c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.5,0-1.1-0.5-1.5-0.9c-0.2-0.3-0.6-0.4-0.9-0.4c-0.3,0-0.7,0.2-0.9,0.5c-1.3,1.7-2,3.8-2.1,6c0,5.4,4.3,9.9,9.7,10.1H16c2.6,0,5-1,6.9-2.8c2-1.8,3.1-4.3,3.1-7V20c0-0.6-0.4-1-1-1c-0.2,0-0.4,0.1-0.6,0.2l0,0l-0.1,0.1C23.1,20.1,21.2,21,20,21c-0.5,0-1-0.2-1-1c0-0.4,0.9-1.1,1.7-1.6c1.4-1,3.1-2.2,3.3-4.3c0.2-2.1-1-3.7-3.6-5c-2.8-1.4-1.9-4.7-1.5-5.7l0-0.1C19,3.2,19,3.1,19,3c0-0.5-0.4-1-1-1h-0.2C14.2,2.1,10,3.8,10,8c0,1.6,0.9,3,1.6,4C12,12.5,12.2,12.9,12.4,13.2 M21.5,25.8c-1.6,1.5-3.6,2.3-5.8,2.2C11.5,27.9,8,24.2,8,20c0-1.5,0.4-2.8,1.1-4.1c0.5,0.4,1.3,0.8,2.2,0.9c0.6,0,1.5-0.1,2.4-1c1.5-1.6,0.5-3.5-0.4-4.8C12.7,10,12,9,12,8c0-2.8,2.9-3.6,4.6-3.9c-0.5,2.5,0,5.3,2.9,6.8c2.3,1.2,2.5,2.2,2.4,3c-0.1,1.2-1.3,2-2.5,2.9C18.3,17.7,17,18.6,17,20c0,2.2,1.8,3,3,3c1.2,0,2.7-0.6,3.8-1.2C23.4,23.3,22.7,24.7,21.5,25.8z"/>
                      <rect fill="none" width="32" height="32"/>
                    </g>
                  </g>
                </svg>, 
                text: 'Flammables' 
              },
              { 
                icon: <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32" height="32" viewBox="0 0 32 32" style={{enableBackground:"new 0 0 32 32"}} xmlSpace="preserve" fill="currentColor" aria-hidden="true">
                  <g id="Layer_2">
                    <g>
                      <path d="M15,4h-5V2h5V4z M24,15v13c0,1.1-0.9,2-2,2H10c-1.1,0-2-0.9-2-2V9.8L10,5h5l1.1,2C20.5,7.1,24,10.6,24,15z M10,10.2V23h12v-8c0-3.3-2.7-6-6-6h-1.1l-1.1-2h-2.5L10,10.2z M22,28v-3H10v3H22z M20,15c0-2.2-1.8-4-4-4C16,13.2,17.8,15,20,15z"/>
                      <rect fill="none" width="32" height="32"/>
                    </g>
                  </g>
                </svg>, 
                text: 'Oxidizers' 
              },
              { 
                icon: <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32" height="32" viewBox="0 0 32 32" style={{enableBackground:"new 0 0 32 32"}} xmlSpace="preserve" fill="currentColor" aria-hidden="true">
                  <g id="Layer_2">
                    <g>
                      <path d="M20,4h-8V2h8V4z M24,15.7V28c0,1.1-0.9,2-2,2H10c-1.1,0-2-0.9-2-2V15.7c0-1.3,0.5-2.6,1.5-3.5L12,9.6V5h8v4.6l2.5,2.5C23.5,13.1,24,14.3,24,15.7z M22,15.7c0-0.8-0.3-1.6-0.9-2.1L18,10.4V7h-4v3.4l-3.1,3.1c-0.6,0.6-0.9,1.3-0.9,2.1V28h12V15.7z M18.3,16.3L16,18.6l-2.3-2.3l-1.4,1.4l2.3,2.3l-2.3,2.3l1.4,1.4l2.3-2.3l2.3,2.3l1.4-1.4L17.4,20l2.3-2.3L18.3,16.3z"/>
                      <rect fill="none" width="32" height="32"/>
                    </g>
                  </g>
                </svg>, 
                text: 'Toxins' 
              },
              { 
                icon: <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32" height="32" viewBox="0 0 32 32" style={{enableBackground:"new 0 0 32 32"}} xmlSpace="preserve" fill="currentColor" aria-hidden="true">
                  <g id="Layer_2">
                    <g>
                      <path d="M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M27.8,14h-6.2c-0.2-0.7-0.6-1.4-1.1-1.9l3.1-5.3C25.8,8.6,27.3,11.1,27.8,14z M8.4,6.8l3.1,5.3c-0.5,0.5-0.8,1.2-1.1,1.9H4.2C4.7,11.1,6.2,8.6,8.4,6.8z M11.8,27.2l3.1-5.3C15.2,22,15.6,22,16,22s0.8,0,1.1-0.1l3.1,5.3C18.9,27.7,17.5,28,16,28C14.5,28,13.1,27.7,11.8,27.2z M22,26.4l-3-5.2l-1-1.7c-0.6,0.3-1.3,0.5-2,0.5s-1.4-0.2-2-0.5l-1,1.7l-3,5.2C6.4,24.3,4,20.4,4,16h8c0-0.7,0.2-1.4,0.5-2c0.3-0.6,0.8-1.1,1.5-1.5l-1-1.7l-3-5.2c1.8-1,3.8-1.6,6-1.6c2.2,0,4.2,0.6,6,1.6l-3,5.2l-1,1.7c0.6,0.4,1.1,0.9,1.5,1.5c0.3,0.6,0.5,1.3,0.5,2h8C28,20.4,25.6,24.3,22,26.4z M18,16c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-1.1,0.9-2,2-2S18,14.9,18,16z"/>
                      <rect fill="none" width="32" height="32"/>
                    </g>
                  </g>
                </svg>, 
                text: 'Radioactive' 
              },
              { 
                icon: <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32" height="32" viewBox="0 0 32 32" style={{enableBackground:"new 0 0 32 32"}} xmlSpace="preserve" fill="currentColor" aria-hidden="true">
                  <g>
                    <path d="M28,8H4c-1.1,0-2,0.9-2,2v16c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V10C30,8.9,29.1,8,28,8z M4,26V10h24l0,16H4z M12,7H6V5h6V7z M26,7h-6V5h6V7z M20,17h6v2h-6V17z M10,17h2v2h-2v2H8v-2H6v-2h2v-2h2V17z"/>
                    <rect fill="none" width="32" height="32"/>
                  </g>
                </svg>, 
                text: 'Corrosives' 
              },
              { 
                icon: <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32" height="32" viewBox="0 0 32 32" style={{enableBackground:"new 0 0 32 32"}} xmlSpace="preserve" fill="currentColor" aria-hidden="true">
                  <g id="Layer_2">
                    <g>
                      <path d="M5.4,28L4,26.6l2.9-2.9l1.4,1.4L5.4,28z M28,4v9h-1.9L13.2,25.8c-0.4,0.4-0.9,0.6-1.4,0.6c-0.5,0-1-0.2-1.4-0.6l-4.2-4.2c-0.8-0.8-0.8-2,0-2.8L19,5.9V4H28z M14,13.8v8.5l4-4V9.8L14,13.8z M11.8,24.4l0.2-0.2v-8.5l-4.4,4.4L11.8,24.4z M26,6h-4.2L20,7.8v8.5l6-6V6z"/>
                      <rect fill="none" width="32" height="32"/>
                    </g>
                  </g>
                </svg>, 
                text: 'Explosives' 
              },
              { 
                icon: <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32" height="32" viewBox="0 0 32 32" style={{enableBackground:"new 0 0 32 32"}} xmlSpace="preserve" fill="currentColor" aria-hidden="true">
                  <g id="Layer_2">
                    <g>
                      <path d="M25,7.4V6h2v1.4c0,0.7,0.3,1.3,0.9,1.7l0.3,0.2c1.1,0.7,1.8,2,1.8,3.3V14h-2v-1.4c0-0.7-0.3-1.3-0.9-1.7l-0.3-0.2C25.7,10,25,8.7,25,7.4z M10.4,18H5v-2h5.2c0.1-0.2,0.2-0.5,0.4-0.7l1.1-1.3H5c-1.1,0-2,0.9-2,2H2v2h1c0,1.1,0.9,2,2,2h7.5l0.1-1h-0.4C11.5,19,10.8,18.6,10.4,18z M26.4,16l-0.8-0.8c-0.7-0.7-1.8-1.2-2.8-1.2h-3.3l-0.1,1h0.4c0.7,0,1.4,0.4,1.8,1h1.2c0.5,0,1,0.2,1.4,0.6l0.4,0.4l-0.4,0.4c-0.4,0.4-0.9,0.6-1.4,0.6h-0.9c-0.1,0.2-0.2,0.5-0.4,0.7L20.3,20h2.4c1.1,0,2.1-0.4,2.8-1.2l0.8-0.8H30v-2H26.4z M19.8,17h-2.5l0.5-6.3c0-0.2-0.2-0.3-0.4-0.2l-5.3,6.1c-0.1,0.1,0,0.4,0.2,0.4h2.5l-0.5,6.3c0,0.2,0.2,0.3,0.4,0.2l5.3-6.1C20.1,17.2,20,17,19.8,17z"/>
                      <rect fill="none" width="32" height="32"/>
                    </g>
                  </g>
                </svg>, 
                text: 'E-cigarettes' 
              }
            ].map((item, index) => {
              const isECigarettes = item.text === 'E-cigarettes';
              const iconColor = isECigarettes ? '#d14904' : undefined;
              const textColorClass = isECigarettes ? 'text-[#d14904]' : 'text-aa-blue';
              
              return (
                <button
                  key={index}
                  type="button"
                  className="flex flex-col items-center p-3 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <div className={`mb-3 flex items-center justify-center ${textColorClass}`} style={{minHeight: '48px'}}>
                    {typeof item.icon === 'string' ? (
                      <span className="text-4xl">{item.icon}</span>
                    ) : (
                      React.cloneElement(item.icon, { 
                        width: "32",
                        height: "32",
                        fill: iconColor || 'currentColor',
                        style: { ...item.icon.props.style, fill: iconColor || 'currentColor' }
                      })
                    )}
                  </div>
                  <div className={`text-sm text-center font-medium ${textColorClass}`}>{item.text}</div>
                </button>
              );
            })}
          </div>

          <div className="">
            <div className="flex justify-end">
              <div className="text-[18px] text-gray-700 text-right">
                By clicking Continue, I agree to the above<br />
                <button type="button" className="text-aa-blue underline">
                  Hazardous materials policy
                </button>{' '}
                and the liquids, aerosols and gels<br />
                regulations.
              </div>
            </div>
          </div>
        </div>

        {/* Continue Button */}
        <div className="flex justify-end">
          <button
            type="button"
            className="bg-aa-blue text-white px-24 py-2 text-lg rounded-lg font-medium hover:bg-blue-500 transition-colors"
          >
            Continue
          </button>
        </div>

        {/* Passenger Modal */}
        <PassengerModal 
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          passengerNumber={selectedPassenger || 1}
        />
      </div>
    </div>
  );
};

export default Passenger;